import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'app-dialog-common-message',
    templateUrl: 'dialog_common_message.component.html',
    styleUrls: ['dialog_common_message.scss']
})
export class DialogCommonMessage implements OnInit {

    title: any;
    array : any;
    message : any;

    constructor(
        public dialogRef: MatDialogRef<DialogCommonMessage>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit() {
        this.title = this.data.title;
        this.array = this.data.array;
        this.message = this.data.message;
    }

    dismissDialog(){
        this.dialogRef.close();
    }
}
